export const userData = [
    {
      name: "Jan",
      "Active User": 4000,
    },
    {
      name: "Feb",
      "Active User": 3000,
    },
    {
      name: "Mar",
      "Active User": 5000,
    },
    {
      name: "Apr",
      "Active User": 4000,
    },
    {
      name: "May",
      "Active User": 3000,
    },
    {
      name: "Jun",
      "Active User": 2000,
    },
    {
      name: "Jul",
      "Active User": 4000,
    },
    {
      name: "Agu",
      "Active User": 3000,
    },
    {
      name: "Sep",
      "Active User": 4000,
    },
    {
      name: "Oct",
      "Active User": 1000,
    },
    {
      name: "Nov",
      "Active User": 4000,
    },
    {
      name: "Dec",
      "Active User": 3000,
    },
  ];

  export const userRows = [
    { id: 1, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 2, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 3, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 4, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 5, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 6, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 7, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
    { id: 8, name_en: 'nour ali', name_ar: "نور العلي", desc_en: "Description Description Description Description", desc_ar: "وصف وصف وصف وصف وصف",image: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",thumbnail: "https://media-cdn.tripadvisor.com/media/photo-s/14/3c/f9/94/4k-restaurant-koh-samui.jpg",color: "#36ADB0" },
];